module.exports = __webpack_public_path__ + "img/kit A&S2.20ff591a.jpg";